/**
 * Indexer API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
package indexer.codegen

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

/**
 *
 * @param subaccountNumber
 * @param address
 */
@JsExport
@Serializable
data class IndexerTransferResponseObjectSender(

    val subaccountNumber: kotlin.Int? = null,
    val address: kotlin.String? = null
)
